import { FC, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { INITIAL_ACCOUNT_CREATE } from 'pages/Accounts/Accounts.constants';
import { AccountCreate } from 'pages/Accounts/Accounts.entity';
import { useCreateAccountMutation } from 'pages/Accounts/api/accounts';
import { AccountCreateForm } from 'pages/Accounts/components';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

type Props = {
  onRefresh: () => void;
};

export const CreateUserModal: FC<Props> = ({ onRefresh }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState(INITIAL_ACCOUNT_CREATE);

  const [createAccount] = useCreateAccountMutation();

  const employeeDateSource = useMemo(() => {
    const defaultFilter = [['hasAccount', '=', false], 'and', ['status', '=', 0]];
    return $createDataSource('/v1/employee', 'id', { defaultFilter });
  }, []);

  const storeRole: any = useMemo(() => {
    return $createDataSource('/v1/role', 'id', { pageSize: 20, paginate: false });
  }, []);

  const handleChange = (name: keyof AccountCreate, value: AccountCreate[keyof AccountCreate]) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid) return;

    createAccount(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Учетная запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание пользователя"
      visible
      isLoadingSubmit={false}
      width={500}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <AccountCreateForm
        employeeDateSource={employeeDateSource}
        form={form}
        onChange={handleChange}
        roleSource={storeRole}
      />
    </ModalForm>
  );
};
